import React, { useMemo } from 'react';
import Rectangle from 'react-rectangle';

const AspectRatioScreenContent = ({ children, className, relation }) => {
  const isTallerOrSquare = useMemo(() => {
    if (!relation.resolution_width || !relation.resolution_height) return false;
    return relation.resolution_height / relation.resolution_width >= 1;
  }, [relation.resolution_width, relation.resolution_height]);

  return (
    <div
      className="contentRectangle"
      style={{ flexDirection: isTallerOrSquare ? 'row' : 'column' }}
    >
      <Rectangle
        className={`${className || 'rectangle'}`}
        aspectRatio={[relation.resolution_width, relation.resolution_height]}
        style={{
          height: isTallerOrSquare ? '100%' : null,
          width: !isTallerOrSquare ? '100%' : null,
          aspectRatio: `${relation.resolution_width} / ${relation.resolution_height}`
        }}
      >
        {children ? <div className="alignImage">{children}</div> : null}
      </Rectangle>
    </div>
  );
};

export default AspectRatioScreenContent;
